<template>
  <div class="active-detail">
    <div class="active-detail__header">
      <!-- <van-image
        class="active-detail__header-gallery"
        :src="getImageFullUrl(data.smImg)"
      /> -->
      <img
        class="active-detail__header-gallery"
        :src="data.smImg"
        @click="getImageFullUrl(data.smImg)"
      />
      <div class="active-detail__header-info">
        <div class="active-detail__header-info-title">
          <span class="active-detail__header-info-title-label"
            >【{{ data.smLabel }}】</span
          >
          <span>{{ data.smTitle }}</span>
        </div>
        <div
          v-for="detailInfoItem in detailInfoList.slice(0, -1)"
          :key="detailInfoItem.icon"
          class="active-detail__header-info-item"
        >
          <img
            class="active-detail__header-info-item-icon"
            :src="detailInfoItem.icon"
          />
          <div class="active-detail__header-info-item-wrapper">
            <span class="active-detail__header-info-item-value">{{
              detailInfoItem.render(data)
            }}</span>
            <img
              v-for="(action, i) in detailInfoItem.actions || []"
              :key="i"
              :src="action.icon"
              class="active-detail__header-info-item-action"
              @click="() => onHeaderDetailActionClick(action)"
            />
          </div>
        </div>

        <div
          class="active-detail__header-info-item active-detail__header-info-item--progress"
        >
          <img
            class="active-detail__header-info-item-icon"
            :src="detailInfoList.slice(-1)[0].icon"
          />
          <div class="active-detail__header-info-item-wrapper">
            <span v-if="data.smNum !== 0" class="active-detail__header-info-item-value">报名进度</span>
            <span v-if="data.smNum == 0" class="active-detail__header-info-item-value">已报名{{ data.smApplyNum }}人</span>
          </div>
        </div>

        <div class="active-detail__header-info-item-progress" v-if="data.smNum != 0">
          <div class="active-detail__header-info-item-progress-bar">
            <div
              class="active-detail__header-info-item-progress-bar-inner"
              :style="{ width: `${(data.smApplyNum / data.smNum) * 100}%` }"
            ></div>
          </div>
          <div class="active-detail__header-info-item-progress-text">
            {{ data.smApplyNum }} / {{ data.smNum }}
          </div>
        </div>
      </div>
    </div>

    <div class="active-detail__content">
      <div class="active-detail__section">
        <div class="FirstLevelTitle">
          <div>活动详情</div>
        </div>
        <div class="active-detail__section-body">
          <div
            class="active-detail__section-active-detail"
            v-html="
              data.smContent ? data.smContent.replace(/(\r)?\n/g, '<br/>') : ''
            "
          />
        </div>
      </div>
    </div>

    <div v-if="actionConfig" class="active-detail__footer">
      <van-button
        :color="actionConfig.color"
        block
        @click="actionConfig.action"
        >{{ actionConfig.text }}</van-button
      >
    </div>

    <van-dialog
      v-model="isQrCodeActive"
      :showConfirmButton="false"
      closeOnClickOverlay
      closeOnPopstate
    >
      <van-image class="active-detail__qrcode-image" :src="data.smWechat" />
      <van-button
        class="active-detail__qrcode-image-btn"
        type="info"
        round
        @click="onSaveQrCodeBtnClick"
      >
        保存二维码
      </van-button>
    </van-dialog>

    <van-action-sheet
      v-model="isDialActive"
      :actions="[{ name: `联系人电话：${data.smPhone}` }]"
      cancel-text="取消"
      close-on-click-action
      @select="onDialogActionSelect"
    />

    <van-dialog
      v-model="isSuccessDialogActive"
      :showConfirmButton="false"
      closeOnPopstate
    >
      <div>
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityTop"
        />
        <div class="active-list__success-dialog-title">
          报名成功<br />
          你一定要来哟~
        </div>
        <div class="active-list__success-dialog-main">
          <div class="active-list__success-dialog-main-title">
            {{ data.smTitle }}
          </div>
          <div class="active-list__success-dialog-main-info-item">
            发起单位：{{ data.smCompany }}
          </div>
          <div class="active-list__success-dialog-main-info-item">
            起止时间：{{
              `${dayjs(data.smStartTime).format("MM.DD HH:mm")} - ${dayjs(
                data.smEndTime
              ).format("MM.DD HH:mm")}`
            }}
          </div>
          <div class="active-list__success-dialog-main-info-item">
            活动地点：{{ data.smAddress }}
          </div>
        </div>
        <div v-if="user">
          <div class="active-list__success-dialog-main-user-info">
            <span class="active-list__success-dialog-main-user-info-label"
              >姓名</span
            >：{{ user.name }}
          </div>
          <div class="active-list__success-dialog-main-user-info">
            手机号码：{{ user.phone }}
          </div>
        </div>
        <van-button
          class="active-list__success-dialog-main-btn"
          type="info"
          round
          @click="onSuccessDialogBtnClick"
        >
          知道了
        </van-button>
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityBottom"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import download from "@/utils/download";
import getAppConfig from "@/utils/getAppConfig";
import IconAddress from "@/assets/image/active/btn_fangzi_nor.png";
import IconTime from "@/assets/image/active/btn_shijian_nor.png";
import IconLocation from "@/assets/image/active/btn_dizhi_nor.png";
import IconPosition from "@/assets/image/active/btn_daohang_nor.png";
import IconPerson from "@/assets/image/active/btn_renyuan_nor.png";
import IconTel from "@/assets/image/active/btn_dianhua_nor.png";
import IconQRCode from "@/assets/image/active/btn_erweima_nor.png";
import IconProgress from "@/assets/image/active/btn_baoming_nor.png";
import BgNewActivityTop from "@/assets/image/active/btn_shang_nor.png";
import BgNewActivityBottom from "@/assets/image/active/btn_xia_nor.png";

dayjs.extend(duration);

const detailInfoList = Object.freeze([
  {
    icon: IconAddress,
    render: (data) => data.smCompany,
  },
  {
    icon: IconTime,
    render: (data) =>
      `${(data.smStartTime || "").slice(5)} - ${(data.smEndTime || "").slice(
        5
      )}`,
  },
  {
    icon: IconLocation,
    render: (data) => data.smAddress,
    // actions: [{ icon: IconPosition, action: 'position' }],
  },
  {
    icon: IconPerson,
    render: (data) => data.smContacts,
    actions: [
      { icon: IconTel, action: "tel" },
      { icon: IconQRCode, action: "qrcode" },
    ],
  },
  {
    icon: IconProgress,
    render: (data) => data.smContacts,
  },
]);

export default {
  components: {
    VNode: {
      props: {
        vNode: {
          type: Object,
          required: true,
        },
      },
      render() {
        return this.vNode;
      },
    },
  },

  data() {
    return {
      dayjs,
      BgNewActivityTop,
      BgNewActivityBottom,
      isSuccessDialogActive: false,
      isQrCodeActive: false,
      isDialActive: false,
      detailInfoList,
      data: {},
      currentDate: new Date(),
      status: null,
      user: null,
    };
  },

  computed: {
    actionConfig() {
      if (this.status === null) return null;
      const noop = () => {};
      const applyMap = {
        yes: [1, 2, "1", "2"],
        no: [3, "3"],
      };

      const configMap = {
        1: {
          text: "我要报名",
          color: "#00706E",
          action: async () => {
            try {
              await this.$http({
                url:
                  `/schoolActivity/FreeApplyInfo?` +
                  `userId=${window.localStorage.getItem("user_id")}` +
                  `&schoolActivityId=${this.data.smId}`,
                headers: { "content-type": "application/json" },
                data: "100",
                method: "POST",
              });
              this.isSuccessDialogActive = true;
            } catch (error) {
              console.error(error);
            }
          },
        },
        2: {
          text: "已报名",
          color: "#00706E",
          action: noop,
        },
        3: {
          text:
            "报名时间：" +
            dayjs(this.status.sbhAppleStartTime).format("MM月DD日 HH:mm") +
            " - " +
            dayjs(this.status.sbhAppleEndTime).format("MM月DD日 HH:mm"),
          color: "#F7A833",
          action: noop,
        },
        4: {
          text: "报名已结束",
          color: "#BFBFBF",
          action: noop,
        },
        5: {
          text: "报名人数已满",
          color: "#BFBFBF",
          action: noop,
        },
        6: {
          text:
            "距离活动开始还有" +
            dayjs
              .duration(
                dayjs(this.status.sbhStartTime).toDate().valueOf() -
                  this.currentDate
              )
              .format("DD天 HH小时mm分钟ss秒"),
          color: "#F7A833",
          action: noop,
        },
        7: {
          text: "活动进行中",
          color: "#BFBFBF",
          action: noop,
        },
        8: {
          text: "活动已结束",
          color: "#BFBFBF",
          action: noop,
        },
      };

      const applyStatus = this.status.applyStatus;

      const applyDateRange = [
        this.status.sbhAppleStartTime,
        this.status.sbhAppleEndTime,
      ];
      const activityDateRange = [
        this.status.sbhStartTime,
        this.status.sbhEndTime,
      ];

      const currentDate = this.currentDate;

      const isBefore = (date, target) => dayjs(date).isBefore(dayjs(target));
      const isAfter = (date, target) => dayjs(date).isAfter(dayjs(target));

      let status;

      if (isBefore(currentDate, applyDateRange[0])) {
        status = 3;
      } else if (!isAfter(currentDate, applyDateRange[1])) {
        if (applyMap.yes.includes(applyStatus)) {
          status = 2;
        } else if (this.data.smApplyNum >= this.data.smNum) {
          status = 5;
        } else {
          status = 1;
        }
      } else if (applyMap.yes.includes(applyStatus)) {
        if (isBefore(currentDate, activityDateRange[0])) {
          status = 6;
        } else if (!isAfter(currentDate, activityDateRange[1])) {
          status = 7;
        } else {
          status = 8;
        }
      } else {
        status = 4;
      }

      return configMap[status] || configMap[1];
    },
  },

  created() {
    this.initTimer();
    this.fetchData();
    this.fetchUser();
  },

  methods: {
    onSuccessDialogBtnClick() {
      this.isSuccessDialogActive = false;
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },

    async fetchUser() {
      const result = await this.$http.get("/myBusinessCard/getBusinessCard", {
        params: {
          userId: window.localStorage.getItem("user_id"),
        },
      });
      this.user = result.data.detailInfo || {};
    },
    async fetchStatus(id) {
      const result = await this.$http.get(
        "/schoolActivity/getActivityShowByName",
        {
          params: {
            userId: window.localStorage.getItem("user_id"),
            id: id,
          },
        }
      );
      this.status = result.data.ActivityShowByName;
    },
    onSaveQrCodeBtnClick() {
      console.log("save", this.data.smWechat);
      download(this.data.smWechat);
    },
    onDialogActionSelect() {
      const link = document.createElement("a");
      link.href = `tel:${this.data.smPhone}`;
      link.click();
    },
    onHeaderDetailActionClick(action) {
      const actionMap = {
        tel: () => {
          this.isDialActive = true;
        },
        qrcode: () => {
          this.isQrCodeActive = true;
        },
        position: () => {
          this.$router.push({
            path: "/map",
            query: {
              keyword: this.data.smAddress,
              region: this.data.smCity,
            },
          });
        },
      };
      actionMap[action.action]();
    },
    getImageFullUrl(url) {
      return getAppConfig(`localUrl`) + url;
    },
    initTimer() {
      this.timer = setInterval(() => {
        this.currentDate = new Date().valueOf();
      }, 1000);

      this.$on("hook:beforeDestroy", () => {
        clearInterval(this.timer);
      });
    },
    async fetchData() {
      const result = await this.$http.get(
        "/schoolActivity/searchActivityList",
        {
          params: {
            currentPage: 1,
            perpage: 1,
            title: this.$route.query.title,
          },
        }
      );

      this.data = result.data.list[0] || {};

      this.fetchStatus(this.data.smId);
    },
  },
};
</script>

<style lang="less" scoped>
.active-detail {
  min-height: 100%;
  // background: #f1f2f3;
}

.active-detail__header {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  width: 95vw;
  margin-left: 2.5vw;
  margin-top: 10px;
  border-radius: 0.5rem;
}

.active-detail__header-gallery {
  width: 100%;
  object-fit: cover;
  min-height: 13.71rem;
  // border:1px solid #E0E0E0;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.active-detail__header-info {
  background-color: #fff;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.active-detail__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.active-detail__header-info {
  padding: 0.95rem 1.49rem;
}

.active-detail__header-info-title {
  font-weight: bold;
  font-size: 1rem;
  color: #333333;
  margin-bottom: 0.8rem;
}

.active-detail__header-info-item {
  display: flex;
  align-content: flex-start;
  // line-height: 18rem;

  & + & {
    margin-top: 0.5rem;
  }
}

.active-detail__header-info-item-icon {
  flex: 0 0 auto;
  width: 1rem;
  height: auto;
  align-self: self-start;
}

.active-detail__header-info-item-wrapper {
  flex: 1 1 auto;
  min-width: 0;
}

.active-detail__header-info-item-value {
  font-size: 0.9rem;
  color: #666666;
  margin-left: 0.84rem;
}

.active-detail__header-info-item-action {
  width: 0.95rem;
  height: 0.95rem;
  margin-left: 8px;
  vertical-align: middle;
}

.active-detail__header-info-title-label {
  color: #d90a0a;
  margin-left: -0.7rem;
}

.active-detail__content {
  margin-top: 0.42rem;
  // background-color: #fff;
}

.active-detail__section {
  padding: 1.33rem 1.14rem;
}

.active-detail__section-header {
  position: relative;
  font-size: 1.14rem;
  color: #333333;
  line-height: 1.9rem;
  padding-left: 0.42rem + 0.19rem;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0.19rem;
    height: 1.1rem;
    background-color: #00706e;
    border-radius: 0.1rem;
  }
}

.active-detail__section-body {
  margin-top: 0.91rem;
  // background: #ffffff;
  border-radius: 1rem;
  border: 1px solid #e0e0e0;
  background: #fff;
  padding: 1rem 0.8rem;
}

.active-detail__section-org {
}

.active-detail__section-active-detail {
  // font-size: 0.9rem;
  // color: #333333;
  // line-height: 1.71rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 25px; //行间距
  color: #747474;
  // text-indent: 4ch;//首行缩进
  text-align: justify; //两端对齐
  .contentTxt {
    padding: 0.5rem 1rem 1rem 1rem;
    line-height: 25px;
  }
}

.active-detail__header-info-item--progress {
  flex-wrap: wrap;
}

.active-detail__header-info-item-progress {
  margin-top: 0.88rem;
  display: flex;
  align-items: center;
}

.active-detail__header-info-item-progress-bar {
  flex: 1 1 auto;
  // height: 0.76rem;
  background: #f5f5f5;
  border-radius: 0.38rem;
  border: 1px solid #cbcbcb;
  padding: 2px;
  box-sizing: border-box;
}

.active-detail__header-info-item-progress-bar-inner {
  background: #00706e;
  border-radius: 0.27rem;
  height: 0.53rem;
}

.active-detail__header-info-item-progress-text {
  flex: 0 0 auto;
  margin-left: 1em;
}

.active-detail__qrcode-image {
  display: block;
  width: 12rem;
  margin: 50px auto 0;
}

.active-detail__qrcode-image-btn {
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 30px;
}

.active-list__new-activity-content-bg {
  display: block;
  width: 100%;
}

.active-list__success-dialog-title {
  font-size: 1.6rem;
  color: #00706e;
  line-height: 2.29rem;
  text-align: center;
}

.active-list__success-dialog-main {
  margin: 1.45rem 1.18rem 1.49rem;
  width: auto;

  background: #f5f5f5;
  border-radius: 1.14rem;
  padding: 0.95rem 0.48rem;
}

.active-list__success-dialog-main-title {
  font-size: 1.07rem;
  color: #333333;
  margin-bottom: 0.95rem;
}

.active-list__success-dialog-main-info-item {
  font-size: 0.91rem;
  color: #666666;
}

.active-list__success-dialog-main-btn {
  display: block;
  margin: 1.82rem auto 1.82rem;
  width: 13.33rem;
  height: 3.24rem;
  background: linear-gradient(270deg, #00706e, #00706e);
  border-radius: 1.62rem;

}

.active-list__success-dialog-main-user-info {
  padding: 0 1.79rem;
  font-size: 1.07rem;
  // line-height: 1.25em;
  color: #333333;
}

.active-list__success-dialog-main-user-info-label {
  display: inline-block;
  width: 4em;

  text-align: justify;
  text-align-last: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/active/ActiveDetails.vue